import { useState } from 'react';
import { CalendarClock, X } from 'lucide-react';

const pad = (n) => String(n).padStart(2, '0');
const nowLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const scheduledLabel = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString([], { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
};

// Optional advance-order service date/time. Blank = normal immediate order.
export const ScheduledServiceField = ({ value, onChange }) => {
  const [open, setOpen] = useState(!!value);
  if (!open && !value) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid="pos-schedule-open-btn"
        className="inline-flex items-center gap-1 text-xs font-medium text-sky-700 hover:underline">
        <CalendarClock size={13} /> Schedule for later
      </button>
    );
  }
  return (
    <div className="flex items-center gap-2" data-testid="pos-schedule-field">
      <CalendarClock size={14} className="text-sky-700 shrink-0" />
      <input type="datetime-local" min={nowLocal()} value={value} onChange={(e) => onChange(e.target.value)}
        className="h-9 px-2 text-xs rounded-lg border border-border" data-testid="pos-schedule-input" />
      <button type="button" onClick={() => { onChange(''); setOpen(false); }} title="Clear — immediate order"
        className="p-1 rounded-md text-muted-foreground hover:bg-muted" data-testid="pos-schedule-clear-btn">
        <X size={14} />
      </button>
    </div>
  );
};

export const ScheduledBadge = ({ iso, testId }) => (iso ? (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-sky-100 text-sky-800 border border-sky-200"
    data-testid={testId || 'scheduled-badge'}>
    <CalendarClock size={11} /> {scheduledLabel(iso)}
  </span>
) : null);
